import { Divider, ScrollArea, Stack } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { useStrategyStore } from '../../../../../store/strategy-store/strategy-store';
import { primaryBase, purpleBase } from '../../../../../styles/design-tokens';
import { SideSectionInfo } from '../../../initiative-list/side-section/side-section-info';
import { ProgressBar } from '../../../initiative-list/side-section/side-section-progress';

export const FiltersProgress = () => {
  const i18n = useTranslation();
  const initiative = useStrategyStore((state) => state.initiativePerformance);

  if (!initiative) {
    return null;
  }

  return (
    <ScrollArea h="100%" scrollbarSize={0}>
      <Stack>
        <ProgressBar
          value={initiative.percent_progress}
          label={i18n.t('strategy.initiative_performance.completion')}
          color={primaryBase}
        />
        <ProgressBar
          value={initiative.percent_elapsed}
          label={i18n.t('strategy.initiative_performance.time_elapsed')}
          color={purpleBase}
        />
        <SideSectionInfo entity={initiative} entityType="initiative" />
        <Divider />
      </Stack>
    </ScrollArea>
  );
};
